var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "padding-top-5xl", attrs: { id: "pro-vs-pro-plus" } },
    [
      _c("div", { staticClass: "row margin-bottom-4xl" }, [
        _c("div", { staticClass: "column-12 text-center" }, [
          _c(
            "h2",
            {
              staticClass: "text-uppercase size-md with-anchor",
              staticStyle: {
                "letter-spacing": "var(--letter-spacing-3xl)",
                "font-weight": "var(--font-weight-black)",
                color: "var(--fa-md-gravy)",
              },
            },
            [
              _c("anchor-link", {
                attrs: {
                  anchor: "#pro-vs-pro-plus",
                  "link-color": "gravy",
                  "anchor-name": "Today's Specials",
                },
              }),
              _vm._v("\n        Today's Specials\n      "),
            ],
            1
          ),
          _vm._v(" "),
          _c("h1", { staticClass: "h2 margin-y-md" }, [
            _vm._v("Go Pro (or Pro+)"),
          ]),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "line-length-xl margin-auto" },
            [
              _vm._v(
                "\n        All plans come with our Classic, Sharp, Duotone, and Sharp Duotone icon packs, including Pro features and services. But you'll need a Pro+ plan to get\n        our new Pro+ icon packs. "
              ),
              _c("site-link", { attrs: { to: { name: "plans" } } }, [
                _vm._v("View all our plans"),
              ]),
              _vm._v(
                " and get the details about what's included in each.\n      "
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row align-center" }, [
        _c(
          "div",
          { staticClass: "column-12 tablet:column-6 laptop:column-4" },
          [
            _c("compare-plan-card", {
              attrs: {
                sku: "FA-STANDARD",
                description:
                  "A permanent license to FA Pro, access to icon downloads, and a year of services.",
                "plan-name": "Pro",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column-12 tablet:column-6 laptop:column-4" },
          [
            _c("compare-plan-card", {
              attrs: {
                sku: "FA-STANDARD-PLUS",
                "all-icon-packs": "",
                "plan-color": "teal",
                description:
                  "Plus plans have everything in our Pro plans, plus extra!",
                "plan-name": "Pro+",
                "plan-tier": "plus",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column-12 tablet:column-6 laptop:column-4" },
          [_c("sale-cta")],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }